export const showCuCa = (domain) => {
    const domains = ['ae', 'sa'];
    return domains.includes(domain)
}


// WEBPACK FOOTER //
// ./src/constants/showCuCa.js